
import React, { PureComponent, useCallback, useMemo, memo } from 'react'
// import CustomRendererSheet from '../components/DataSheet_Duke7';
import PF from '../../_Services/publicFunction';
import _ from 'lodash';
import CustomRendererSheet from "./VirtualSheet"
import { isEqual } from 'lodash';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { useTheme } from '@material-ui/styles';
import { useDispatch, useSelector } from "react-redux";

const R = require('ramda');



const InteriorTable = memo(props => {
    const { selected, setSelected
        , setRows, rows, orderRows, setOrderRows
        , showColumns, setColumns, columns
        , multiChk, checkSelections, setCheckSelections, enableCheck
        , listRef
        , pageCount, pageNo, setPageNo
        , handleDoubleClick
        , defaultFrozen //預設凍結數量
        , defaultWidth  //預設表格寬度
        , RowStyleFunc  //一行的背景顏色
        , CopyWithHeader //複製表頭
    } = props;
    let theme = useTheme();
    const { dark } = useSelector(state => ({
        dark: state.app.dark,
    }));
    const { i18n } = useSelector(state => ({
        i18n: state.app.i18n,
    }));
    const [labelCount, setLabelCount] = React.useState({ count: 0, sum: 0, avg: 0, count2: 0 })
    const [frozen, setFrozen] = React.useState(defaultFrozen || 0)   //凍結數

    const onSelect = (selected) => {
        if (rows.length > 0) {

            //解構
            const { start, end } = selected;
            const grid = [...orderRows];
            // console.log(rows)
            // console.log(orderRows)

            // console.log(grid)
            const height = Math.abs(start.i - end.i) + 1  //計算選取範圍height
            const width = Math.abs(start.j - end.j) + 1   //計算選取範圍width
            //
            let columnStart = start.j <= end.j ? start.j : end.j;
            let columnEnd = start.j <= end.j ? end.j : start.j;
            let rowStart = start.i <= end.i ? start.i : end.i;
            let rowEnd = start.i <= end.i ? end.i : start.i;

            let newArr = [];
            for (let i = rowStart; i <= rowEnd; i++) {
                for (let j = columnStart; j <= columnEnd; j++) {
                    newArr.push(orderRows[i][j])
                }
            }

            function NumAddAverage(accumulator, a) {
                if (Object.keys(accumulator).length === 0) {
                    accumulator = { sum: 0, count: 0 } //初始化用
                }
                //accumulator==={}?{accumulator.sum:0,accumulator.NumCount:0}
                if (!isNaN(a) && !_.isNil(a) && a !== "") {//先檢查是否為數字&&不能為空=>YES
                    accumulator.sum = accumulator.sum + parseFloat(a);  //轉換為數字
                    accumulator.count = accumulator.count + 1;  //數字的count
                    return accumulator;//將字串轉換為數字
                } else {
                    return accumulator
                }
            }

            const ArrayObjectToArray = arr => {
                return R.map(obj => obj['value'], arr);
            };


            let sum_avg = ArrayObjectToArray(newArr).reduce(NumAddAverage, {})
            //  console.log(ArrayObjectToArray(newArr))

            // console.log(end);
            // console.log(KeepArrayReducer(grid, start.i, end.i));
            //console.log("個數："+height*width);
            //this.setState({labelCount:"Count:"+height*width+" "+(sum_avg.count===0?"":" Sum:"+ccyFormat2(sum_avg.sum)+" Avg:"+ccyFormat2(sum_avg.sum/sum_avg.count))});
            //this.setState(prevState => ({ labelCount: { ...prevState.labelCount, count: height * width, count2: 0 } }));
            setLabelCount(prevState => ({
                ...prevState.labelCount,
                count: height * width,
                count2: sum_avg.count > 0 ? sum_avg.count : 0,
                sum: sum_avg.count > 0 ? sum_avg.sum : 0,
                avg: sum_avg.count > 0 ? sum_avg.sum / sum_avg.count : 0,
            }))
            setSelected(selected);

        }
    }
    const onRowClick = (rowIndex) => {
        const grid = [...orderRows];
        const columnNo = grid[0].length
        let start = { i: rowIndex, j: 0 }
        let end = { i: rowIndex, j: columnNo - 1 }
        onSelect({ start, end })
    }
    const handleRowDrop = (from, to) => {
        // const grid = _.cloneDeep(rows);
        let j = PF.swapArrayLocs(rows, from, to);
        // console.log(showColumns)
        setRows(prev => j)
        setOrderRows(prev => PF.dataSheetGridFormat(j, Object.keys(showColumns)))

        //選擇框也須更著變更
        const columnNo = orderRows[0].length

        let start = { i: to, j: 0 }
        let end = { i: to, j: columnNo - 1 }

        onSelect({ start, end })

        setCheckSelections(prevState => new Map([
            ...prevState,
            [from, prevState.get(to)],  //對調
            [to, prevState.get(from)], //對調
        ]));
    }
    const onHeaderClick = (colIndex) => {
        const rowNo = rows.length
        let start = { i: 0, j: colIndex }
        let end = { i: rowNo - 1, j: colIndex }
        // console.log(rows);
        // console.log(orderRows);
        onSelect({ start, end })
    }
    const onTotalClick = (colIndex) => {
        //若點了左上角，代表全選
        const grid = [...orderRows];
        const rowNo = grid.length
        const colNo = Object.keys(showColumns).length
        // console.log()
        let start = { i: 0, j: 0 }
        let end = { i: rowNo - 1, j: colNo - 1 }
        onSelect({ start, end })
    }
    //換欄=>調換順序
    const handleColumnDrop = (from, to) => {
        //表頭更改順序
        // const { setRows, setColumns, columns, rows, OriginalColumns, OriginalRows } = this.props;
        //const columns = [...this.props.columns];
        // console.log([...this.state.columns],"原來的表頭")
        // console.log(from, to)
        const columnsX = _.cloneDeep(Object.values(showColumns));
        //console.log(columnsX,"原來的表頭")
        //columnsX.splice(to, 0, ...columnsX.splice(from, 1))


        let x = PF.swapArrayLocs(columnsX, from, to);
        // console.log(x)
        let y = columnsX.map(item => {
            return [item.name, item]
        })
        let z = _.merge(Object.fromEntries(y), columns);


        // console.log(z, "更新的表頭")
        setColumns(z);

        let noshowTable = [];
        Object.values(z).map(item => {
            if (item.noshowTable === true) {
                // console.log(item.name)
                noshowTable.push(item.name)
            }
        })
        let showColumns2 = _.omit(z, noshowTable); //過濾不顯示的

        setOrderRows(prev => PF.dataSheetGridFormat(rows, Object.keys(showColumns2)))
        //表身更改順序

        //選擇框也須更著變更
        const rowNo = orderRows.length
        let start = { i: 0, j: to }
        let end = { i: rowNo - 1, j: to }
        onSelect({ start: start, end: end })

    }
    const renderCell = (prop) => {
        const { col, cells, className, cell, attributesRenderer,
            selected, editing, updated, style,
            ...rest } = prop;
        let columns = Object.values(showColumns);

        let accWidth = 0;
        let styles = {};
        if (col + 1 <= frozen) {
            accWidth = columns.slice(0, col).reduce((a, b) => a + b.width, 0)
            styles = {
                left: enableCheck ? 85 + accWidth : 30 + accWidth,
                position: "sticky",
                // "z-index": 100,
                // width:"500px",
                background: !dark ? "#FFFF7D" : "#ab003c",
                border: "1px solid #a2a2a2",
                textAlign: columns[col].tableFormat === "number" ? "right" : "left"
            }

        }
        const Normalattributes = _.cloneDeep(cell.attributes) || {}
        Normalattributes.title = cell.value;    //hover show content
        Normalattributes.style = {
            textAlign: columns[col].tableFormat === "number" ? "right" : "left"
        };    //hover show content

        const Frezzeattributes = _.cloneDeep(cell.attributes) || {}
        Frezzeattributes.style = styles;
        Frezzeattributes.title = cell.value;    //hover show content
        if (col + 1 <= frozen) { //欲凍結的窗口
            return (//NOTE：...props要先
                <td className={className} width={columns[col].width} col={col} cells={cells} {...rest} {...Frezzeattributes}  >
                    {prop.children}
                </td>)
        } else {  //NOTE：...props要先
            return <td className={className} width={columns[col].width} col={col} cells={cells} {...rest}  {...Normalattributes} >
                {prop.children}
            </td>
        }
    }
    return (
        <CustomRendererSheet
            FrozenColumn={frozen}            //凍結數量
            setFrozen={setFrozen}           //凍結方法
            isMultipleCheckSelection={multiChk} //允許多選checkBOx
            data={orderRows}                    //需轉換格式
            setOrderRows={setOrderRows}           //傳入方法
            OriginalRows={rows}         //原來傳入
            columns={Object.values(showColumns)} //需轉換格式
            setColumns={setColumns}     //傳入方法
            OriginalColumns={columns}   //原來傳入
            enableCheck={enableCheck}
            checkSelections={checkSelections}       //checkBox
            setCheckSelections={setCheckSelections} //checkBox方法
            listRef={listRef}   //用來scroll to an item
            pageCount={pageCount}
            pageNo={pageNo}
            setPageNo={setPageNo}
            //以上reqiured
            handleDoubleClick={handleDoubleClick}
            valueRenderer={c => c.value}
            onCellsChanged={f => f}
            cellRenderer={useCallback(renderCell, [columns, orderRows, frozen, theme])}
            // cellRenderer={renderCell}

            onSelect={onSelect}
            selected={selected}
            labelCount={labelCount}
            onTotalClick={onTotalClick}
            // onHeaderClick={useCallback(index => onHeaderClick(index), [rows])}
            onHeaderClick={onHeaderClick}
            // onColumnDrop={useCallback((f, t) => handleColumnDrop(f, t), [columns])}
            onColumnDrop={handleColumnDrop}
            onRowClick={onRowClick}
            onRowDrop={handleRowDrop}
            defaultWidth={defaultWidth}
            RowStyleFunc={RowStyleFunc}
            CopyWithHeader={CopyWithHeader}
            i18n={i18n}
        />
    )
}, isEqual)

export default InteriorTable